export const ROLES = {
  instructor: 'instructor',
  learner: 'learner',
  original_user: 'original_user',
  publisherAdmin: 'publisher_admin',
  publisherRep: 'publisher_rep',
  unknown: 'unknown',
  unverifiedInstructor: 'unverified_instructor',
  verifiedInstructor: 'verified_instructor'
}
